export function getStringLength(str) {
    if(!str){
        return 0;
    }
    let len = 0;

    for (let i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
            len += 2;
        } else {
            len++;
        }
    }

    return len;
}
/**
 * 日期格式化
 * @param date Date 目标日期对象/String 日期对应字符串/ Number: 时间戳(精确到毫秒)
 *        String fmt 指定格式字符串月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q)可以用 1-2 个占位符、年(y)可以用 1-4 个占位符、毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * @return Boolean
 */
export function dateFormatter(dateTmp, fmtTmp) {
    let fmt = fmtTmp;
    let date = dateTmp;

    if (!fmt) {
        fmt = 'yyyy.MM.dd';
    }
    if (!(date instanceof Date)) {
        date = new Date(date);
    }
    let o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    let week = {
        "0": "日",
        "1": "一",
        "2": "二",
        "3": "三",
        "4": "四",
        "5": "五",
        "6": "六"
    };

    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? "星期" : "周") : "") + week[date.getDay() + ""]);
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}

/**
 * 时间戳格式化(创建时间倒序排列；当天用时分，当周用几天前，其他用年月日)
 * @param Object
 * @return Boolean
 */
export function formatDateMinus(time, systime) {
    let nowDate = new Date(systime * 1000);

    nowDate.setHours(23);
    nowDate.setMinutes(59);
    nowDate.setSeconds(59);
    let day = nowDate.getDay();
    let dayMinus = parseInt((Date.parse(nowDate) / 1000 - time) / (60 * 60 * 24));

    if (dayMinus == 0) {
        return dateFormatter(time * 1000, 'HH:mm');
    } else if (dayMinus == 1) {
        return '昨天';
    } else if (dayMinus < 7 && (day - dayMinus > 0 || day == 0)) {
        return dayMinus + '天前';
    } else {
        return dateFormatter(time * 1000);
    }
}
export function getTimestamp(date) {
    return Date.parse(date) / 1000;
}
// 获取零点时间
export function getZeroDate() {
    let currDate = new Date();
    let year = currDate.getFullYear();
    let month = currDate.getMonth();
    let day = currDate.getDate();

    return new Date(year, month, day, 0, 0, 0);
}
/**
 * 根绝出生时间计算年龄
 * @param birthTime 出生时间戳(秒)
 * @return age
 */
export function getAgeFromBirth(birthTime) {
    if (!birthTime) {
        return '--';
    }
    var returnAge;
    var birthDate = new Date(birthTime * 1000);
    var birthYear = birthDate.getFullYear();
    var birthMonth = birthDate.getMonth();
    var birthDay = birthDate.getDate();

    var d = new Date();
    var nowYear = d.getFullYear();
    var nowMonth = d.getMonth();
    var nowDay = d.getDate();

    if (nowYear == birthYear) {
        returnAge = 0; //同年 则为0岁
    } else {
        var ageDiff = nowYear - birthYear; //年之差

        if (ageDiff > 0) {
            if (nowMonth == birthMonth) {
                var dayDiff = nowDay - birthDay; //日之差

                if (dayDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            } else {
                var monthDiff = nowMonth - birthMonth; //月之差

                if (monthDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            }
        } else {
            returnAge = '未知'; //返回-1 表示出生日期输入错误 晚于今天
        }
    }
    return returnAge; //返回周岁年龄
}
/** 验证url合法性 */
export function isValidURL(url){
    // var urlRegExp=/^((https|http|ftp|rtsp|mms)?:\/\/)+[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\':+!]*$/;
    var urlRegExp=/^(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[^\s]*$/;

    if(urlRegExp.test(url)){
        return true;
    }else{
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js